import React from "react"
import "./location-style.css"
import "./style.css"

const LocationShowcase = () => {
  const locations = [
    {
      name: "શુભ લગ્ન સ્થળ",
      address: "શનેશ્વર પાર્ટી પ્લોટ, મવડી-પાળ રોડ, રાજકોટ 360004",
      locationUrl: "https://maps.app.goo.gl/8gZBohaBnff5u8E78",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="location-icon" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
    },
    {
      name: "શુભ નિવાસ સ્થાન",
      address: "\"શ્રીજી નિવાસ\" 4/એ , પંચાયત નગર, સૌરાષ્ટ્ર યુનિવર્સિટી મેઈન રોડ, રાજકોટ 350005",
      locationUrl: "https://maps.app.goo.gl/piwf9ZyW73FJ778R6",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="location-icon" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      ),
    },
  ]

  const handleLocationClick = (address) => {
    window.open(address, "_blank")
  }

  return (
    <div className="location-showcase-container">
      <h1 className="address-heading">સરનામું</h1>
      <div className="location-showcase">
        {locations.map((location, index) => (
          <div key={index} className="location-card" onClick={() => handleLocationClick(location.locationUrl)}>
            <div className="location-header">
              <div className="icon-wrapper">{location.icon}</div>
              <h2 className="location-name">{location.name}</h2>
            </div>
            <p className="location-address">{location.address}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LocationShowcase


